import { Box, Button, Typography } from "@mui/material"
import { type FC, useState } from "react"

const ToggleButton = ({ isExpanded, onClick }: { isExpanded: boolean; onClick: () => void }) => (
  <Button
    variant='text'
    className='cursor-pointer capitalize text-primary'
    onClick={onClick}
    data-testid='toggle-cas-numbers-button'
  >
    {isExpanded ? "Hide All" : "View All"}
  </Button>
)

export const TechnicalInformationCasNumbers: FC<{ casRegistryIds: string[] }> = ({ casRegistryIds }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const isMultiple = Array.isArray(casRegistryIds) && casRegistryIds.length > 1

  if (!isMultiple) {
    return (
      <Box className='mt-3 flex-1 text-left text-sm'>
        <Typography variant='body2' className='mb-3 flex-1 text-left text-sm'>
          {casRegistryIds?.[0] || "-"}
        </Typography>
      </Box>
    )
  }

  return (
    <Box className='mt-3 flex-1 text-left text-sm'>
      {!isExpanded ? (
        <Box className='mb-3 flex flex-row items-center justify-between'>
          <Typography variant='body2' className='flex-1 text-left text-sm'>
            Multiple
          </Typography>
          <ToggleButton isExpanded={false} onClick={() => setIsExpanded((prev) => !prev)} />
        </Box>
      ) : (
        <Box className='mb-1 flex flex-row items-end justify-between'>
          <Box className='flex flex-col'>
            {casRegistryIds.map((id) => (
              <Typography key={id} variant='body2' className='mb-2 flex-1 text-left text-sm'>
                {id}
              </Typography>
            ))}
          </Box>
          <ToggleButton isExpanded={true} onClick={() => setIsExpanded((prev) => !prev)} />
        </Box>
      )}
    </Box>
  )
}
